<template>
  <div id="userTemplate">
    <div>
      <userHeader></userHeader>
    </div>
    <router-view />
  </div>
</template>

<script>
  import userHeader from "@/components/navigation/userHeader.vue";
  export default {
    name: 'UserTemplate',
    components: {
      userHeader
    },
  }
</script>

<style>
</style>
